<template>
  <button v-on="$listeners"
          :class="['button',
                   {'button_full': full},
                   {'button_outline': outline},
                   {'button_outline-primary': outlinePrimary},
                   {'button_secondary': secondary},
                   {'is-disabled': disabled},
                   {'is-loading': loading}]">
    <span class="button__content">
      <span class="button__title">
        <slot/>
      </span>
    </span>
  </button>
</template>

<script>
  import ButtonController from '@/components/buttons/button-controller'

  export default {
    name: 'Button',
    mixins: [ButtonController]
  }
</script>
